import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <>
      <footer>
        <p>Copyright &copy; Easy Coding 2022</p>
      </footer>
    </>
  );
};
export default Footer;
